<template>
    <el-dialog
        :append-to-body="true"
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
    >
    <div>
        <template v-for="(o, index) in data">
            <el-button :key="index" @click="() => {
                $emit('change', o)
                dialogVisible = false
            }">{{o}}</el-button>
        </template>
    </div>
    </el-dialog>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        dialogVisible: false
      };
    },
    methods: {
        open () {
            this.dialogVisible = true
        }
    }
  };
</script>